"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineOfCoverageTypeSelectInput = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importStar(require("react"));
var definitions_1 = require("../../hooks/definitions");
/**
 * Select with all lines of coverage types (except for the ones in the optional blacklist)
 */
function LineOfCoverageTypeSelectInput(_a) {
    var value = _a.value, _b = _a.blacklist, blacklist = _b === void 0 ? [] : _b, onChange = _a.onChange;
    var _c = definitions_1.useDefinitionsHelpers(), lineOfCoverageTypes = _c.lineOfCoverageTypes, renderLineOfCoverageType = _c.renderLineOfCoverageType;
    // all LOCs except the ones in the blacklist
    var options = react_1.useMemo(function () {
        return lineOfCoverageTypes
            .filter(function (type) { return !blacklist.includes(type); })
            .map(function (type) { return ({ value: type, label: renderLineOfCoverageType(type) }); });
    }, [lineOfCoverageTypes, renderLineOfCoverageType, blacklist]);
    var handleChange = react_1.useCallback(function (val) { return onChange(val); }, [onChange]);
    return react_1.default.createElement(core_ui_1.AdvancedSelectInput, { isClearable: true, value: value, options: options, onChange: handleChange });
}
exports.LineOfCoverageTypeSelectInput = LineOfCoverageTypeSelectInput;
